import { mapState, mapGetters } from 'vuex'
import {
  setCreditsSignRemain,
  getUserCreditsTake,
  directNotify,
  getShareText,
} from '@/utils/service'
import { eventJoin } from "@/request/cash.js";
import { getActivityParams } from '@/request/index'
import { callApp, isAphone, jumpPage, isIphone } from '@/utils/mUtil'
import { getCommonParam } from '@/utils/logic'
import TaskList from '@/components/task-list'
import InviteTipDialog from '@/components/invite-tip-dialog'
import InviteResultDialog from '@/components/invite-result-dialog'
import ruleDialog from '@/components/rule-dialog'
import { getDeviceInfo } from '@/utils/service'
import { AppApi } from '@/utils/appApi'
import { EventBus } from '@/utils/eventBus';

export const TEST_TASKS = []
const THIRD_TASK = ['42', '44', '43', '31', '35', '41']
// 签到提醒逻辑
export const remainStatusMixin = {
  created() {
    // console.log(this.taskInfo)
    this.remainStatus = this.taskInfo.remainStatus === 1
    this.$watch('remainStatus', (newvalue, oldval) => {
      this.updateRemainStatus(newvalue)
      this.$store.commit('switchSignRemind')
    })
  },

  methods: {
    async updateRemainStatus(remainStatus) {
      const status = remainStatus ? 1 : -1
      const DEVICEINFO = await getDeviceInfo()
      const { pushSwitch } = DEVICEINFO || {}
      const data = {
        evt: '6',
        act: String(status),
        pushSwitch,
      }
      const value = JSON.stringify(data)
      Report.click({ value })
      try {
        const data = await setCreditsSignRemain({
          hideLoading: true,
          status,
        })
      } catch (error) {
        console.log(error)
      }
    },
  },
}

// 登录的逻辑
export const loginMixin = {
  methods: {
    clickLogin() {
      if (this.isMGTV) {
        MgtvApi.login(() => {
          location.reload()
        })
      } else {
        // app外走引流下载流程
        callApp()
      }
    },
  },
  computed: {
    ...mapState(['isMGTV']),
  },
}

let isPageHidden = false;

// 任务的逻辑
export const taskMixin = {
  components: {
    TaskList,
    InviteTipDialog,
    InviteResultDialog,
    ruleDialog,
  },
  data: () => {
    return {
      showRule: false,
      showInviteTip: false,
    }
  },
  methods: {
    // 现金任务
    doMoneyTask({ thirdExchange, taskSign }) {
      // 浏览性任务，点击直接完成
      if (thirdExchange.canTriggered && taskSign) {
        eventJoin({
          taskSign,
        });
      }
      try {
        if (thirdExchange.scheme) {
          location.href = thirdExchange.scheme;
          setTimeout(() => {
            if (!isPageHidden) {
              AppApi.jumpPage({ url: thirdExchange.h5Download, disableEncode: '1' });
            }
          }, 600);
        } else {
          AppApi.jumpPage({ url: thirdExchange.h5Download, disableEncode: '1' });
        }
      } catch (error) {
        console.log('跳转现金任务h5失败：', error);
      }
    },
    godo(taskId, url) {
      Report.click({
        value:
          '{"evt": "2", "typ": "' + taskId + '", "step": "0", "curDay": ""}',
      })
      if (!this.isLogin) {
        return this.clickLogin()
      }

      if (TEST_TASKS.includes(taskId) && this.thirdChannel) {
        return this.toThird(url)
      }

      if (THIRD_TASK.includes(taskId)) {
        return this.toThird(url)
      }

      if ([2, 5, 6, 7, 9].includes(+taskId)) {
        // 观看视频 || 写评论 || 分享视频 || 发表弹幕 || 新手任务
        return isAphone()
          ? (location.href = window.prefix + 'subjectpage?subjectid=' + url)
          : (location.href = window.prefix + 'subjectpage?subjectId=' + url)
      }

      // 绑定手机
      if (taskId == 8) {
        this.$store.commit('setBindPhone', true)
        return jumpPage(
          'https://app.hitv.com/passport/cn/aphone/bindphone/index.html'
        )
      }

      if (taskId == 3) {
        // 打开消息通知
        Report.click({
          value: '{"evt": "7"}',
        })

        return MgtvApi.openSettingPage()
      }

      if (taskId == 14) {
        Report.click({
          value: '{"evt": "5022"}',
        })

        return jumpPage(
          'https://app.mgtv.com/MangoKid/?isHideNavBar=1&isFullScreen=1&from=jifenrenwu&t=20190510'
        )
      }

      if (taskId == 16 || taskId == 19) {
        isIphone() ? (location.href = url) : jumpPage(url)
        return
      }

      if (taskId == 39) {
        this.showInviteTip = true
        return
      }

      // 点击即完成的浏览积分任务
      if ([30, 38, 40, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60].includes(Number(taskId))) {
        this.directNotify(taskId)
      }

      jumpPage(url)
    },
    // 跳转第三方
    toThird(url) {
      getActivityParams(url).then((res) => {
        if (res.code === 200) {
          // window.location.href = res.data.scheme
          // setTimeout(() => {
          //   if (!Page.isHidden()) {
          //   }
          // }, 3000)
          if (url.indexOf('imgotv://') == -1) {
            MgtvApi.jumpPage({ url: res.data.h5Download, disableEncode: '1' })
          } else {
            location.href = res.data.h5Download
          }
        }
      })
    },
    async directNotify(type) {
      try {
        const res = await directNotify(type)

        this.$store.dispatch('getTaskInfo')
        this.list.forEach((item) => {
          item.list.forEach((task) => {
            if (task.taskId == 22 && task.curStep < task.maxStep) {
              this.isShowAd()
            }
          })
        })
      } catch (error) {}
    },

    async goget(taskId) {
      Report.click({
        value:
          '{"evt": "2", "typ": "' + taskId + '", "step": "1", "curDay": ""}',
      })
      if (!this.isLogin) {
        return this.clickLogin()
      }
      const commonParams = getCommonParam(taskId)
      const data = await this._getUserCreditsTake(commonParams)
      this.$emit('recevice', data.credits)

      // 如果是作为mixin传入父组件
      this.taskGetVisible = true
      this.taskGetScore = data.credits

      // 更新积分
      this.$store.dispatch('getUserCreditsBalanceAction')
      // 更新任务列表
      this.$store.dispatch('getTaskInfo')
      // v2 更新积分信息
      this.$store.dispatch('queryCashUserInfo')
    },

    async _getUserCreditsTake(params) {
      try {
        const res = await getUserCreditsTake(params)
        return res
      } catch (errmsg) {
        this.$toast(errmsg.msg)
      }
    },
  },
  mounted() {
    // 监听页面重新显示事件
    EventBus.$on('page-reshow', () => {
      isPageHidden = false;
    });

    AppApi.registerhandler('webviewEnterBackground', {}, () => {
      isPageHidden = true;
    })
  },
  destroyed() {
    EventBus.$off('page-reshow');
  },
  computed: {
    ...mapState(['taskInfo']),
    ...mapGetters(['isLogin']),
    thirdChannel() {
      return this.$route.query.thirdChannel == 1
    }
  },
}
